interface TravellerValue {
	type?: unknown;
	name?: string | null;
	value?: string | null;
	validationRules?: Array<{ required?: boolean | null } | null> | null;
}

type TravellerFormValues = Record<string, string | null | undefined>;

type MappedTravellerValue<T extends TravellerValue> = {
	type: T['type'];
	name: T['name'];
	value: string | null;
};

export const prepareTravellerValues = <T extends TravellerValue>(
	values: T[],
	formValues?: TravellerFormValues
): MappedTravellerValue<T>[] => {
	const result: MappedTravellerValue<T>[] = [];

	for (const value of values) {
		const formValue = formValues ? formValues[value.name ?? ''] : value.value;
		const isRequired = value.validationRules?.some(rule => rule?.required) ?? false;

		if (formValue !== undefined || isRequired) {
			result.push({
				type: value.type,
				name: value.name,
				value: formValue !== undefined ? formValue : null
			});
		}
	}

	return result;
};
